import { loadModules } from 'esri-loader';
import mapConfig from '../config/mapConfig';

export default class MapConfigHelper {
  static async createCustomBasemap(config, name) {
    const [
      Basemap,
      TileLayer,
      VectorTileLayer,
      FeatureLayer,
      MapImageLayer
    ] = await loadModules([
      'esri/Basemap',
      'esri/layers/TileLayer',
      'esri/layers/VectorTileLayer',
      'esri/layers/FeatureLayer',
      'esri/layers/MapImageLayer'
    ]);
    const [basemapDef] = config.filter(c => c.id === name);
    if (basemapDef) {
      const customBasemapLayers = [];
      basemapDef.baseMapLayers.forEach(lyr => {
        switch (lyr.type) {
          case 'feature-layer':
            customBasemapLayers.push(new FeatureLayer(lyr.layerDef));
            break;
          case 'tile-layer':
            customBasemapLayers.push(new TileLayer(lyr.layerDef));
            break;
          case 'vector-tile-layer':
            customBasemapLayers.push(new VectorTileLayer(lyr.layerDef));
            break;
          case 'map-image-layer':
            customBasemapLayers.push(new MapImageLayer(lyr.layerDef));
            break;
        }
      });
      return new Basemap({
        baseLayers: customBasemapLayers,
        title: basemapDef.title,
        id: basemapDef.id,
        thumbnailUrl: basemapDef.thumbnailUrl
      });
    } else {
      return undefined;
    }
  }

  static async getBasemap(basemapConfig) {
    const [Basemap] = await loadModules(['esri/Basemap']);
    let basemap;
    if (
      typeof basemapConfig !== 'string' &&
      basemapConfig.hasOwnProperty('id')
    ) {
      basemap = new Basemap({ portalItem: basemapConfig });
    } else {
      // check and see if basemap config refers to a custom basemap
      const customBasemap = await MapConfigHelper.createCustomBasemap(
        mapConfig.customBasemaps,
        basemapConfig
      );
      if (customBasemap) {
        basemap = customBasemap;
      } else {
        // asssume its a well known basemap ID
        basemap = Basemap.fromId(basemapConfig);
      }
    }
    return basemap;
  }

  static async getDefaultBasemap() {
    return MapConfigHelper.getBasemap(mapConfig.defaultBasemap);
  }

  static async getAllBasemaps() {
    const basemaps = [];
    const defaultBasemap = await MapConfigHelper.getDefaultBasemap();
    basemaps.push(defaultBasemap);
    for (let item in mapConfig.basemaps) {
      let config = mapConfig.basemaps[item];
      const basemap = await MapConfigHelper.getBasemap(config);
      basemaps.push(basemap);
    }
    return basemaps;
  }
}
